import * as React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Filters from "./Filters";
import { Button, LinearProgress, Link, Typography, useMediaQuery } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../app/store/configureStore";
import { useEffect } from "react";
import {
  entrezDbSelectors,
  fetchESearchResultsAsync,
  fetchESummaryOrEFetchAsync,
  updateSelectedDBState,
} from "../../app/store/entrezDbSlice";

import Title from "../../app/components/Title";
import EntrezDBFields from "./notinuse/EntrezDBFields";
import QueryTable from "./notinuse/QueryTable";
import QueryTableEditable from "./QueryTableEditable";

import FinalQuery from "./FinalSearchOperationView";
import TitleSecondary from "../../app/components/TitleSecondary";
import RecentDBs from "./RecentDbs";
import DatabaseInfo from "./DatabaseInfo";
import { entrezConfig } from "../../app/util/entrezConfig";
import EntrezTableWithPaginationTopBottom from "./EntrezTableWithPaginationTopBottom";
import FullScreenDialog from "./FullScreenTableView";
import FinalQueryDisplay from "./FinalQueryDisplay";
import EntrezDBFieldsWithAutoComplete from "./EntrezDBFieldsWithAutoComplete";
import SearchHistoryTable from "./SearchHistoryTable";
import ClearHistoryConfirmation from "./ClearHistoryConfirmation";
import { clearSearchHistory } from "../../app/store/storeHelper";
// import { grid } from "@material-ui/system";

// interface Props {
//   selectedDB: string;
// }

// props: Props
export default function EntrezPage() {
  // const iswidthGreaterthan900 = useMediaQuery("(min-width:900px)");
  // console.log("width greater than 900: " + iswidthGreaterthan900);

  const { dbParams, status } = useAppSelector((state) => state.entrezDb);

  const dispatch = useAppDispatch();

  //dbParams.db must be set before reaching here.
  const selectedDbWithItsState = useAppSelector((state) =>
    entrezDbSelectors.selectById(state, dbParams.db)
  );

  //once its ready to search, hit the api to get the search details
  useEffect(() => {
    console.log("useEffect of eSearch");
    if (selectedDbWithItsState?.isReadyForSearch) {
      console.log("Inside: use effect of eSearch");
      dispatch(fetchESearchResultsAsync());
      console.log("dispatched action to search on click of search button");
      //dispatch(setReadyForSearch({ isReadyForSearch: false }));
    }
  }, [selectedDbWithItsState?.isReadyForSearch, dispatch]);

  //once its search details are available, hit the api to fetch the dbrecords for last search operation
  useEffect(() => {
    console.log("useEffect of eFetch");
    if (selectedDbWithItsState?.isReadyForFetch) {
      console.log("Inside useEffect of eFetch");

      dispatch(fetchESummaryOrEFetchAsync("Details")); //"Summary"
      console.log("dispatched action to fetch db detailed records.");
      //dispatch(setReadyForFetch({ isReadyForFetch: false }));
    }
  }, [selectedDbWithItsState?.isReadyForFetch, dispatch]);


  const handleClearSearchHistory = () => {
    
    console.log("On handleClearSearchHistory");

    clearSearchHistory(dbParams.db);

    dispatch(
      updateSelectedDBState({
        id: dbParams.db,
        changes: {
          searchHistory: [],
        },
      })
    );
  };

  // JSX
  /* flexGrow:1 causing box to take whole space, you can set it to 0 to do the opposite */

  if (!selectedDbWithItsState)
    return <>{/* <p>State not found for selected db.</p> */}</>;


const historyExists = selectedDbWithItsState.searchHistory && selectedDbWithItsState.searchHistory.length>0;

  return (
    <Box sx={{ flexGrow: 1, mt: 1, ml: 1 }}>
      <Grid container columnSpacing={1}>
        {/* sx={{ m: 1 }} */}
        {/* show whole grid for small and medium. For large show both the grids */}
        <Grid item xs={12} md={10} lg={10} sx={{ mt: 0 }}>
          {/* mt: 2, ml: 2, mr: 2  */}
          {/* Fields */}

          <Paper
            sx={{
              mb: 1,
              p: 1,
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Box display="flex">
                <Title>Database:</Title>
                <TitleSecondary>
                  {" "}
                  &nbsp;{" "}
                  {selectedDbWithItsState
                    ? selectedDbWithItsState.displayname
                    : "<Select>"}
                </TitleSecondary>
              </Box>
            </Box> */}

            {/*  */}
            {status.includes("pendingFetchDBDetails") && (
              <Box sx={{ width: "100%" }}>
                <LinearProgress color="secondary" />
              </Box>
            )}
            {/* key property is to clear component on different selections */}
            {/* <EntrezDBFields key={dbParams.db}></EntrezDBFields> */}
            <EntrezDBFieldsWithAutoComplete
              key={dbParams.db}
            ></EntrezDBFieldsWithAutoComplete>
          </Paper>

          {/* Queries Items (Selected fields) */}

          <Paper
            sx={{
              mb: 1,
              width: "100%",
              minWidth: 250,
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* <Title>Query Terms</Title> */}
            {/* <QueryTable onRemove={handleOnRemoveQueryItem} queries={queries} /> */}
            <QueryTableEditable></QueryTableEditable>
          </Paper>

          {/* EFetch result  */}

          <Paper sx={{ mb: 1, p: 1, display: "flex", flexDirection: "column"  }}>
            {status.includes("pendingEFetchESummaryOrEFetchAsync") && (
              <Box sx={{ width: "100%" }}>
                <LinearProgress color="secondary" />
              </Box>
            )}

            {selectedDbWithItsState.dbRecords && (
              <EntrezTableWithPaginationTopBottom></EntrezTableWithPaginationTopBottom>
            )}
          </Paper>

          {/* SearchHistoryTable */}
          <Paper
            sx={{
              mb: 1,
              width: "100%",
              minWidth: 250,
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* <Title></Title>  */}

            <Box
              display="flex"
              flexDirection="row"
              alignItems = "left"
              justifyContent= "space-between"
              sx={{ ml: 1 }}
            >
              <Typography
                component="h2"
                variant="h6"
                color="primary"
                gutterBottom
                sx={{ ml: 2, mt: 1 }}
              >
                Search History
              </Typography>

              <ClearHistoryConfirmation onYes={handleClearSearchHistory} disableButton={!historyExists}></ClearHistoryConfirmation>
            </Box>

            <SearchHistoryTable></SearchHistoryTable>
          </Paper>
        </Grid>

        {/* <Grid item xs={1} md={1} lg={1} sx={{}}>
        <Divider orientation="vertical" flexItem />
      </Grid> */}

        {/* right grid */}
        <Grid item xs={12} md={2} lg={2} sx={{ mt: 0, pr: 1 }}>
          {/*  */}
          <Paper
            sx={{
              mb: 1,
              p: 1,
              width: "100%",
              minWidth: 250,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Title>Database Information</Title>
            {selectedDbWithItsState && (
              <DatabaseInfo
                {...{
                  menuname: selectedDbWithItsState.menuname,
                  description: selectedDbWithItsState.description,
                  count: selectedDbWithItsState.count,
                  lastupdate: selectedDbWithItsState.lastupdate,
                }}
              />
            )}
          </Paper>

          <Paper
            sx={{
              mb: 1,
              p: 1,
              display: "flex",
              flexDirection: "row",
              width: "100%",
              minWidth: 250,

              // ...((selectedDbWithItsState!.finalFormattedSearchTerm ===
              //   null ||
              //   selectedDbWithItsState!.finalFormattedSearchTerm === "") && {
              //   pointerEvents: "none",
              //   opacity: 0.7,
              // }),
            }}
          >
            <FinalQueryDisplay />
          </Paper>

          {/* Publication Dates */}
          {entrezConfig.PublicationDateEligibleDbs.includes(dbParams.db) && (
            <Paper
              sx={{
                mb: 1,
                p: 1,
                display: "flex",
                flexDirection: "row",
                width: "100%",
                minWidth: 250,
              }}
            >
              <Filters />
            </Paper>
          )}

          {/* Recent DBs */}
          <Paper
            sx={{
              mb: 1,
              p: 1,
              display: "flex",
              flexDirection: "row",
              width: "100%",
              minWidth: 250,
            }}
          >
            <RecentDBs></RecentDBs>
          </Paper>
        </Grid>
        {/* End of right grid */}
      </Grid>
    </Box>
  );
}

// {/* mt: 2, mr: 2, ml: 2 */}
// Queries Items (Selected fields)

// <Paper
//   sx={{
//     mb: 1,
//     p: 1,
//     width: "100%",
//     minWidth: 250,
//     display: "flex",
//     flexDirection: "column",
//   }}
// >
//   <Title>Query Terms</Title>
//   {/* <QueryTable onRemove={handleOnRemoveQueryItem} queries={queries} /> */}
//   <QueryTable></QueryTable>
// </Paper>

// {/* Final formatted Query*/}

// {/* <Paper sx={{ mb: 1, p: 1, display: "flex", flexDirection: "column" }}>
//   <Title>Final Query</Title>
//   <FinalQuery></FinalQuery>
//   {/* <FinalQuery onSearch={handleOnSearch} /> */}
// </Paper> */}
